// Colour theme: "system" follows the device setting, "light" and "dark" are
// explicit choices kept in this browser. The resolved theme is written to
// <html data-theme="..."> where the stylesheet and the charts read it.

const STORAGE_KEY = 'theme';
export const THEME_OPTIONS = [
  { value: 'system', label: 'System' },
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' }
];

const listeners = new Set();

const prefersDark = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-color-scheme: dark)').matches;

export const getThemePreference = () => {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === 'light' || stored === 'dark') return stored;
  } catch (e) {}
  return 'system';
};

export const getResolvedTheme = () => {
  const preference = getThemePreference();
  if (preference === 'system') return prefersDark() ? 'dark' : 'light';
  return preference;
};

const applyTheme = () => {
  if (typeof document === 'undefined') return;
  const resolved = getResolvedTheme();
  document.documentElement.setAttribute('data-theme', resolved);
  const themeColor = document.querySelector('meta[name="theme-color"]');
  if (themeColor) themeColor.setAttribute('content', resolved === 'dark' ? '#141414' : '#f4f5f1');
};

const notify = () => {
  applyTheme();
  listeners.forEach((listener) => listener());
};

export const setThemePreference = (preference) => {
  try {
    if (preference === 'light' || preference === 'dark') {
      window.localStorage.setItem(STORAGE_KEY, preference);
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  } catch (e) {}
  notify();
};

export const subscribeTheme = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

// Apply the saved theme and keep following the device setting while the
// preference is "system". index.html applies the theme before first paint;
// this keeps it in sync afterwards.
export const initTheme = () => {
  applyTheme();
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
  const query = window.matchMedia('(prefers-color-scheme: dark)');
  const onChange = () => {
    if (getThemePreference() === 'system') notify();
  };
  if (typeof query.addEventListener === 'function') query.addEventListener('change', onChange);
  else if (typeof query.addListener === 'function') query.addListener(onChange);
};
